import { ErrorMessageContents } from '../../helpers/hub'
import { Book } from './types'

export const fetchBooks = () => ({ type: 'books.fetchBooks' } as const)
export type FetchBooksAction = ReturnType<typeof fetchBooks>

export const fetchBooksFailure = (error: ErrorMessageContents) =>
  ({ type: 'books.fetchBooksFailure', payload: error, error: true } as const)
export type FetchBooksFailure = ReturnType<typeof fetchBooksFailure>

export const addOrUpdateBooks = (books: Book[]) =>
  ({ type: 'books.addOrUpdateBooks', payload: books } as const)
export type AddOrUpdateBooks = ReturnType<typeof addOrUpdateBooks>

export type BookAction = FetchBooksAction | FetchBooksFailure | AddOrUpdateBooks
